import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';
import { DIFFICULTIES } from '../../../lib/constants';

export function DifficultyConfirmDialog({
  showDifficultyConfirm,
  setShowDifficultyConfirm,
  pendingDifficulty,
  onConfirm,
  onCancel
}) {
  return (
    <AlertDialog open={showDifficultyConfirm} onOpenChange={setShowDifficultyConfirm}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Change Difficulty?
          </AlertDialogTitle>
          <AlertDialogDescription>
            You have a game in progress. Changing difficulty will reset your current puzzle and all progress will be lost.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            Keep Playing
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Change to {pendingDifficulty && DIFFICULTIES[pendingDifficulty]?.name}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
